module.exports = __webpack_public_path__ + "static/media/IMG_2310.096ced06.jpg";